export const CT = {
  white: '#FFFFFF',
  paleGrey: '#93A4BD',
  lightGrey: '#5F6E86',
  darkGrey: '#252A31',
  darkBg: '#1B1F26',
  primaryBlue: '#0284FE',
  purple: '#CD9FFF',
  green: '#54DD82',
  blue: '#44A4FF',
  orange: '#FFB456',
  font: "'Basier Circle', 'Inter', system-ui, -apple-system, sans-serif",
} as const;
